<template>
	<div>
		<Modal 
			:loading="loading" 
			:title="current != 'new' ? 'EDITAR ENTREGA' : 'NOVA ENTREGA'"
			@close="close"
			@save="save"
		>
			<div class="row">
				<div class="col-xs">
					<small><b>Informações do emissor</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs">
					<FormSelect v-model="emitter.name_document" label="Emissor" :options="options_my_documents" :required="true" tooltip="Selecione o emissor da entrega" ref="emitter_name_document" />
				</div>
			</div>			
			<div class="row">
				<div class="col-xs">
					<small><b>Informações gerais</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-3">
					<FormSelect v-model="order.type" label="Tipo" :options="options_types" :required="true" tooltip="Selecione o tipo da entrega" ref="order_type" />
				</div>
				<div class="col-xs-12" :class="client_atak ? 'col-lg-6': 'col-lg-9'">
					<FormInput v-model="order.document" label="Número NF/Pedido" type="text" :required="true" tooltip="Informe o número da entrega" ref="order_document" />
				</div>
				<div v-if="client_atak" class="col-xs-12 col-lg-3">
					<FormInput v-model="order.code" label="Código do pedido" type="text" :required="false" tooltip="Informe o código do pedido ('chave de fato' do registro do pedido no sistema integrado)" ref="order_code" />
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-3">
					<FormInput v-model="order.date" label="Data de entrega" type="date" :required="true" tooltip="Informe a data de entrega" ref="order_date" />
				</div>
				<div class="col-xs-12 col-lg-3">
					<FormInputMasked v-model="order.total_weight" label="Peso total" type="tel" :mask="['# kg','## kg','### kg','#### kg','##### kg','###### kg','####### kg','######## kg','######### kg']" tooltip="Informe o peso da entrega" ref="order_total_weight" />
				</div>
				<div class="col-xs-12 col-lg-3">
					<FormInputMasked v-model="order.total_quantity" label="Quantidade total" type="tel" mask="#########" tooltip="Informe a quantidade total de peças/itens/caixas da entrega" ref="order_total_quantity" />
				</div>
				<div class="col-xs-12 col-lg-3">
					<FormInputMasked v-model="order.total_value" label="Valor total" type="tel" :mask="['R$ #,##','R$ ##,##','R$ ###,##','R$ ####,##','R$ #####,##','R$ ######,##','R$ #######,##','R$ #########,##']" tooltip="Informe o valor total da entrega" ref="order_total_value" />
				</div>
			</div>
			<div class="row">
				<div class="col-xs">
					<small><b>Informações do destinatário</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<FormSelect v-model="receiver.name_document_id" label="Cliente" :options="options_my_customers" @input="getAddressCustomer" :required="true" tooltip="Selecione o cliente da entrega" ref="receiver_name_document_id" />
				</div>
				<div v-if="(receiver.name_document_id != '') && (receiver.name_document_id == '0') ? true : false" class="col-xs-4">
					<FormInputMasked v-model="receiver.document" label="CPF/CNPJ" type="tel" :required="true" :mask="['###.###.###-##', '##.###.###/####-##']" tooltip="Informe o documento do novo cliente" ref="receiver_document" />
				</div>
				<div v-if="(receiver.name_document_id != '') && (receiver.name_document_id == '0') ? true : false" :class="client_atak ? 'col-xs-6' : 'col-xs-8'">
					<FormInput v-model="receiver.name" label="Nome" type="text" :required="true" tooltip="Informe o nome do novo cliente" ref="receiver_name" />
				</div>
				<div v-if="(receiver.name_document_id != '') && (receiver.name_document_id == '0') && client_atak ? true : false" class="col-xs-2">
					<FormInput v-model="receiver.code" label="Código do cliente" type="text" :required="false" tooltip="Informe o código do cliente ('chave de fato' do registro do cliente no sistema integrado)" ref="receiver_code" />
				</div>
			</div>
			<form-group-address
				:current_id="receiver.fk_address"
				:current_postal_code="receiver.postal_code"
				:current_street="receiver.street"
				:current_number="receiver.number"
				:current_complement="receiver.complement"
				:current_neighborhood="receiver.neighborhood"
				:current_city="receiver.city"
				:current_uf="receiver.uf"
				:current_country="receiver.country"
				:current_coordinates="receiver.coordinates"
				ref="formGroup"
			>
			</form-group-address>
			<div class="row">
				<div class="col-xs">
					<small><b>Informações de transporte</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-9">
					<FormSelect v-model="driver.name_document" label="Motorista" :options="options_my_drivers" @input="getLicensePlateDriver" tooltip="Informe o motorista que fará o delivery" ref="driver_name_document" />
				</div>
				<div class="col-xs-12 col-lg-3">
					<FormInputMasked v-model="driver.vehicle_plate" label="Veículo" type="text" mask="AAA#X##" tooltip="Informe placa do veículos que fará o delivery" ref="driver_vehicle_plate" />
				</div>
				<div v-if="client_atak" class="col-xs-12 col-lg-4">
					<FormInput v-model="order.code_stock" label="Código do estoque" type="text" tooltip="Informe o código do estoque de origem da entrega ('chave de fato' do estoque registrado no sistema integrado)" ref="order_code_stock" />
				</div>
				<div class="col-xs-12 col-lg-4">
					<FormInput v-model="order.cargo" label="Carga" type="text" tooltip="Informe a carga da entrega" ref="order_cargo" />
				</div>
				<div class="col-xs-12 col-lg-4">
					<FormInputMasked v-model="order.sequence" label="Sequência" type="tel" mask="#########" tooltip="Informe a sequência da entrega no roteiro da carga" ref="order_sequence" />
				</div>
				<div v-if="client_atak" class="col-xs-12 col-lg-4">
					<FormInput v-model="order.code_course" label="Código do percurso" type="text" tooltip="Informe o código do percurso da região de entrega da entrega ('chave de fato' do percurso registrado no sistema integrado)" ref="order_code_course" />
				</div>
				<div v-if="client_atak" class="col-xs-12 col-lg-4">
					<FormInput v-model="order.course" label="Percurso" type="text" tooltip="Informe o nome do percurso da região de entrega da entrega ('nome' do percurso registrado no sistema integrado)" ref="order_course" />
				</div>
			</div>
			<div class="row">
				<div v-if="client_atak" class="col-xs-12 col-lg-4">
					<FormSelect v-model="order.temperature" label="Temperatura" :options="options_temperature" tooltip="Informe a temperatura" ref="order_temperature" />
				</div>
				<div v-if="client_atak" class="col-xs-12 col-lg-4">
					<FormSelect v-model="order.bone" label="Possui osso" :options="options_bone" tooltip="Informe se tem ou não osso" ref="order_bone" />
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-12" style="margin-bottom: 15px">
					<FormTextarea v-model="order.observation" label="Observação" tooltip="Informe uma observação adicional que será exibida ao motorista no processo de entrega" ref="order_observation" />
				</div>
			</div>
			<div class="row">
				<div class="col-xs">
					<small><b>Itens</b></small>
				</div>
			</div>
			<div class="row">
				<div class="col-xs">
					<button class="add-new-product" @click="add_new_product">
						<i class="fa fa-plus"></i> ADICIONAR ITEM
					</button>
				</div>
			</div>
			<div class="col-xs order-list-products">
				<div class="row order-list-products-item" v-for="(product, index) in order.products" :key="index">
					<div class="col-xs-12 col-lg-12">
						<button class="remove-product" @click="remove_product(index)"><i class="fa fa-trash"></i></button>
					</div>
					<div class="col-xs-12 col-lg-4">
						<FormInput v-model="product.code" label="Código" type="text" :required="true" tooltip="Informe o código do item" ref="product_code" />
					</div>
					<div class="col-xs-12 col-lg-8">
						<FormInput v-model="product.description" label="Descrição" type="text" :required="true" tooltip="Informe a descrição do item" ref="product_description" />
					</div>
					<div class="col-xs-12 col-lg-4">
						<FormInputMasked v-model="product.amount" label="Quantidade" type="tel" :mask="['#','##','###','####','#####','######','#######','########','#########']" :required="true" tooltip="Informe a quantidade do item" ref="product_amount" />
					</div>
					<div class="col-xs-12 col-lg-4">
						<FormSelect v-model="product.unit" label="Unidade" :options="options_units" :required="true" tooltip="Selecione a unidade referente a quantidade do item" ref="product_unit" />
					</div>
					<div class="col-xs-12 col-lg-4">
						<FormInputMasked v-model="product.value" label="Valor" type="tel" :mask="['R$ #,##','R$ ##,##','R$ ###,##','R$ ####,##','R$ #####,##','R$ ######,##','R$ #######,##','R$ #########,##']" tooltip="Informe o valor individal do item" ref="product_value" />
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";
import FormTextarea from "@/components/FormTextarea";
import FormGroupAddress from '@/components/FormGroupAddress.vue';

export default {
	name: "DeliveryForm",

	props: {
		current: {
			type: [Object, String],
			required: true,
		},
		my_customers: {
			type: Array,
			required: true,
		},
		my_drivers: {
			type: Array,
			required: true,
		},
		my_documents: {
			type: Array,
			required: true,
		},
	},

	components: {
		Modal,
		FormInput,
		FormInputMasked,
		FormSelect,
		FormTextarea,
		FormGroupAddress,
	},

	data: function() {
		if (this.current != "new") {
			return {
				loading: false,

				emitter: {
					fk_company: this.current.fk_company,
					name_document: this.current.company_name.toUpperCase() + " -" + this.current.customer_document.replace(".", "").replace("/", "").replace("-", ""),
					document: this.current.company_document.replace(".", "").replace("/", "").replace("-", ""),
				},
				
				order: {
					id: this.current.id,
					type: this.current.type == 0 ? 'N' : 'P',
					document: this.current.document_number,
					code: this.current.code ? this.current.code : "",
					date: this.current.date,
					total_weight: this.current.weight,
					total_quantity: this.current.quantity ? this.current.quantity.toString() : "",
					total_value: this.current.xml ? this.current.xml.PAGAMENTO[0].VALOR : 0.00,
					code_stock: this.current.code_stock ? this.current.code_stock : "",
					cargo: this.current.cargo ? this.current.cargo : "",
					sequence: this.current.sequence ? this.current.sequence.toString() : "",
					code_course: this.current.code_course ? this.current.code_course : "",
					course: this.current.course ? this.current.course : "",
					temperature: this.setTemperature(this.current.temperature_ambient, this.current.temperature_chilled, this.current.temperature_frozen),
					bone: this.setBone(this.current.with_bone, this.current.without_bone),
					observation: this.current.observation ? this.current.observation : "",
					products: [],
				},

				receiver: {
					fk_customer: this.current.fk_customer,
					name_document_id: this.current.customer_name.replace("-", "").toUpperCase()  + " - " + this.current.customer_document + " - " + this.current.fk_customer,
					document: this.current.customer_document.replace(".", "").replace("/", "").replace("-", ""),
					code: this.current.customer_code,
					name: this.current.customer_name.toUpperCase(),
					fk_address: this.current.fk_address,
					postal_code: this.current.postal_code,
					street: this.current.street.toUpperCase(),
					number: this.current.number,
					complement: this.current.complement,
					neighborhood: this.current.neighborhood.toUpperCase(),
					city: this.current.city.toUpperCase(),
					uf: this.current.uf.toUpperCase(),
					country: this.current.country.toUpperCase(),
					coordinates: {
						lat: this.current.coordinates.split(",")[0],
						lng: this.current.coordinates.split(",")[1],
					},
				},

				driver: {
					fk_driver: this.current.fk_driver ? this.current.fk_driver : "",
					name_document: this.current.driver_name && this.current.driver_document ? this.current.driver_name.toUpperCase() + " - " + this.current.driver_document : "",
					vehicle_plate: this.current.license_plate.toUpperCase(),
					document: this.current.driver_document.replace(".", "").replace("/", "").replace("-", ""),
					name: this.current.driver_name.toUpperCase(),
				},

				client_atak: this.$api.user.company_client_atak,
			};
		}

		return {
			loading: false,

			emitter: {
				fk_company: '',
				name_document: '',
				document: '',
			},
			
			order: {
				id: '',
				type:'',
				document:'',
				code:'',
				date:'',
				total_weight:'',
				total_quantity:'',
				total_value:'',
				code_stock:'',
				cargo:'',
				sequence:'',
				code_course: '',
				course: '',
				bone: '',
				temperature: '',
				observation: '',
				products: []
			},

			receiver: {
				name_document_id: '0',
				document: '',
				name: '',
				code: '',
				fk_address: '',
				postal_code: '',
				street: '',
				number: '',
				complement: '',
				neighborhood: '',
				city: '',
				uf: '',
				country: '',
				coordinates: null,
			},

			driver: {
				name_document: '',
				vehicle_plate: '',
				document: '',
				name: ''
			},

			client_atak: this.$api.user.company_client_atak,
		};
	},

	computed: {
		options_types: function() {
			return {
				'N': 'NOTA FISCAL',
				'P': 'PEDIDO',
			};
		},
		
		options_bone: function() {
			return {
				0: 'NÃO',
				1: 'SIM',
			};
		},
		
		options_temperature: function() {
			return {
				0: 'AMBIENTE',
				1: 'RESFRIADO',
				2: 'CONGELADO',
			};
		},

		options_units: function() {
			return {
				'G': 'G',
				'KG': 'KG'
			};
		},
		
		options_my_documents: function() {
			let r = {};
			this.my_documents.map(d => {
				r[d.name.toUpperCase() + " - " + d.document] = d.name.toUpperCase() + " - " + d.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
			});
			return r;
		},

		options_my_customers: function() {
			let r = {};
			r["0"] = "NOVO CLIENTE";
			this.my_customers.map(c => {
				r[c.name.replace("-", "").toUpperCase() + " - " + c.document + " - " + c.id] = c.name.toUpperCase() + " - " + (c.document.length > 11 ? c.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : c.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"));
			});
			return r;
		},

		options_my_drivers: function() {
			let r = {};
			this.my_drivers.map(d => {
				r[d.name.toUpperCase() + " - " + d.document] = d.name.toUpperCase() + " - " + d.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			});
			return r;
		},
	},
	
	/*created: function () {
		if (this.current != "new" && this.current.delivery_observation) {
			this.loadObservation();
		}
	},*/

	mounted: function() {
		this.select_document();
	},

	methods: {
		// Carrega a observação
		loadObservation: async function() {
			let res = null;
			try {
				res = await Api.post("delivery-observation/get-observation", {
                    fk_delivery: this.current.id,
                });
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter a observação.");
                this.loading = false;
				return;
			}
			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
			this.order.observation = res.data.observation;
		},

		getAddressCustomer: function() {
			if (this.receiver.name_document_id != "0") {
				let id = this.receiver.name_document_id.split(" - ")[2];
				let customer = this.my_customers.filter(element => { return element.id == id; })[0];
				if (customer) {
					this.receiver.document = customer.document;
					this.receiver.name = customer.name;
					this.receiver.postal_code = customer.postal_code;
					this.receiver.street = customer.street;
					this.receiver.number = customer.number;
					this.receiver.complement = customer.complement;
					this.receiver.neighborhood = customer.neighborhood;
					this.receiver.city = customer.city;
					this.receiver.uf = customer.uf;
					this.receiver.country = customer.country;
					this.receiver.coordinates = {
						lat: customer.coordinates.split(",")[0],
						lng: customer.coordinates.split(",")[1],
					};
				} else {
					this.receiver.document = "";
					this.receiver.name = "";
					this.receiver.postal_code = "";
					this.receiver.street = "";
					this.receiver.number = "";
					this.receiver.complement = "";
					this.receiver.neighborhood = "";
					this.receiver.city = "";
					this.receiver.uf = "";
					this.receiver.country = "";
					this.receiver.coordinates = null;
					this.$refs.formGroup.cleanForm();
					this.$refs.formGroup.cleanMap();
				}
			} else {
				this.receiver.document = "";
				this.receiver.name = "";
				this.receiver.postal_code = "";
				this.receiver.street = "";
				this.receiver.number = "";
				this.receiver.complement = "";
				this.receiver.neighborhood = "";
				this.receiver.city = "";
				this.receiver.uf = "";
				this.receiver.country = "";
				this.receiver.coordinates = null;
				this.$refs.formGroup.cleanForm();
				this.$refs.formGroup.cleanMap();
			}
		},
		
		getLicensePlateDriver: function() {
			let document = this.driver.name_document.split(" - ")[1];
			let driver = this.my_drivers.filter(element => { return element.document == document; })[0];
			
			this.driver.vehicle_plate = driver && driver.license_plate ? driver.license_plate : "";
		},

		select_document: function() {
			if(this.my_documents.length == 1) {
				this.$refs.emitter_name_document.select(this.my_documents[0].name + " - " + this.my_documents[0].document);
			}
		},

		setBone: function(with_bone, without_bone) {
			if ((with_bone != 0) && (without_bone == 0)) return 1;
			else if ((with_bone == 0) && (without_bone != 0)) return 0;
			else return "";
		},

		setTemperature: function(ambient, chilled, frozen) {
			if ((ambient != 0) && (chilled == 0) && (frozen == 0)) return 0;
			else if ((ambient == 0) && (chilled != 0) && (frozen == 0)) return 1;
			else if ((ambient == 0) && (chilled == 0) && (frozen != 0)) return 2;
			else return "";
		},

		// Adiciona um subformulário para um item
		add_new_product: function() {
			let new_product = {
				code: "",
				description: "",
				amount: "",
				unit: "",
				value: ""
			};

			this.order.products.push(new_product);
		},

		// Remove um subformulário de item
		remove_product: function(index) {
			this.order.products.splice(index, 1);
		},

		// Verifica e valida inicialmente os campos
		validation: function() {
			let data = [];
			let dataOrder = [];
			let error = false;

			// Informa que é um novo NF/Pedido
			dataOrder.push("1");

			// Emissor
			if (this.emitter.name_document != "") {
				let emitter = this.emitter.name_document.split(' - ');
				dataOrder.push(emitter[1]); // document
			} else {
				dataOrder.push(""); // document
			}
			
			// NF/Pedido
			if (this.order.type == "") {
				this.$refs.order_type.trigger_blur();
				this.$notification.error(this.message("TIPO"));
				error = true;
			} else {
				dataOrder.push(this.order.type);
			}
			
			if (this.order.document == "") {
				this.$refs.order_document.validate();
				this.$notification.error(this.message("NÚMERO NF/PEDIDO"));
				error = true;
			} else {
				dataOrder.push(this.order.document);
			}
			
			if (this.order.date == "") {
				this.$refs.order_date.validate();
				this.$notification.error(this.message("DATA ENTREGA"));
				error = true;
			} else {
				dataOrder.push(this.order.date);
			}

			dataOrder.push(this.order.total_weight.replace(" kg", ""));
			dataOrder.push(this.order.total_quantity);
			dataOrder.push(this.order.total_value.replace("R$ ", "").replace(",", "."));
			
			// Placa do veículo do motorista
			if (this.driver.vehicle_plate != "") {
				dataOrder.push(this.driver.vehicle_plate.toUpperCase());
			} else {
				dataOrder.push("");
			}
			
			// Motorista
			if (this.driver.name_document != "") {
				let driver = this.driver.name_document.split(' - ');
				dataOrder.push(driver[1]); // document
				dataOrder.push(driver[0]); // name
			} else {
				dataOrder.push(""); // document
				dataOrder.push(""); // name
			}

			// Destinatário
			if (this.receiver.name_document_id == "") {
				this.$refs.receiver_name_document_id.trigger_blur();
				this.$notification.error(this.message("CLIENTE"));
				error = true;
			} else {
				if (this.receiver.name_document_id == "0") {
					if (this.receiver.document == "") {
						this.$refs.receiver_document.validate();
						this.$notification.error(this.message("CPF/CNPJ"));
						error = true;
					} else {
						let id = "0";
						let code = "0";
						if (this.client_atak && this.receiver.code != "") {
							code = this.receiver.code;
						}
						dataOrder.push(this.receiver.document.replace(".", "").replace("-", "") + "_" + id + "_" + code); // document + id + code
					}

					if (this.receiver.name == "") {
						this.$refs.receiver_name.validate();
						this.$notification.error(this.message("NOME"));
						error = true;
					} else {
						dataOrder.push(this.receiver.name);
					}
				} else {
					let customer = this.receiver.name_document_id.split(' - ');
					let code = "0";
					dataOrder.push(customer[1] + "_" + customer[2] + "_" + code); // document + id + code
					dataOrder.push(customer[0]); // name
				}
			}

			let dataAddress = this.$refs.formGroup.validation();
			if (dataAddress) {
				dataOrder.push(dataAddress.postal_code);
				dataOrder.push(dataAddress.street);
				dataOrder.push(dataAddress.number);
				dataOrder.push(dataAddress.complement);
				dataOrder.push(dataAddress.neighborhood);
				dataOrder.push(dataAddress.city);
				dataOrder.push(dataAddress.uf);
			} else {
				error = true;
			}

			dataOrder.push(this.order.cargo);
			dataOrder.push(this.order.sequence);
			
			if (dataAddress) {
				dataOrder.push(dataAddress.country);
				dataOrder.push(dataAddress.coordinates.lat + "," + dataAddress.coordinates.lng);
			} else {
				error = true;
			}

			dataOrder.push(this.order.code_stock);
			
			dataOrder.push(this.order.observation);

			if (this.order.code_course != "") {
				dataOrder.push(this.order.code_course);
			} else {
				if (this.order.course != "") {
					if (this.$refs.order_code_course) {
						this.$refs.order_code_course.error = "Código inválido";
						this.$notification.error("'CÓDIGO DO PERCURSO' também deve ser preenchido.");
						error = true;
					}
				} else {
					dataOrder.push(this.order.code_course);
					if (this.$refs.order_code_course) {
						this.$refs.order_code_course.error = "";
					}
				}
			}
			
			if (this.order.course != "") {
				dataOrder.push(this.order.course);
			} else {
				if (this.order.code_course != "") { 
					if (this.$refs.order_course) {
						this.$refs.order_course.error = "Percurso inválido";
						this.$notification.error("'PERCURSO' também deve ser preenchido.");
						error = true;
					}
				} else {
					dataOrder.push(this.order.course);
					if (this.$refs.order_course) {
						this.$refs.order_course.error = "";
					}
				}
			}

			dataOrder.push(this.order.code);
			
			dataOrder.push(this.order.temperature);

			dataOrder.push(this.order.bone);
			
			data.push(dataOrder);

			// Product
			if (Object.keys(this.order.products).length > 0) {
				for (let i = 0; i < Object.keys(this.order.products).length; i++) {
					let dataItem = [];

					// Informa que é im item de um NF/Pedido
					dataItem.push("2");
					dataItem.push(this.order.type);
					dataItem.push(this.order.document);

					if (this.order.products[i].code == "") {
						this.$refs.product_code[i].validate();
						this.$notification.error(this.message("CÓDIGO PRODUTO"));
						error = true;
					} else {
						dataItem.push(this.order.products[i].code);
					}
					
					if (this.order.products[i].description == "") {
						this.$refs.product_description[i].validate();
						this.$notification.error(this.message("DESCRIÇÃO PRODUTO"));
						error = true;
					} else {
						dataItem.push(this.order.products[i].description);
					}
					
					if (this.order.products[i].amount == "") {
						this.$refs.product_amount[i].validate();
						this.$notification.error(this.message("QUANTIDADE PRODUTO"));
						error = true;
					} else {
						dataItem.push(this.order.products[i].amount);
					}
					
					if (this.order.products[i].unit == "") {
						this.$refs.product_unit[i].trigger_blur();
						this.$notification.error(this.message("UNIDADE PRODUTO"));
						error = true;
					} else {
						dataItem.push(this.order.products[i].unit);
					}

					dataItem.push(this.order.products[i].value.replace("R$ ", "").replace(",", "."));

					data.push(dataItem);
				}
			}

			// Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
		},

		// Retorna menssagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

		// Envia para API e salva as informações no BD e XML
        save: async function() {
			let form = {};

			if (this.current != "new") {
				let confirm = await this.$alert.confirm("Deseja mesmo EDITAR essa entrega?");
				if (!confirm) return;

				form.id = this.current.id;
			}

			let data = this.validation();
			
			if (data == null) {
				return;
			}
			
			form.data = data;
			
			this.loading = true;
			let result = null;
			try {
				result = await Api.post("delivery/save-order", form);
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível processar as informações.");
				this.loading = false;
				return;
			}
			this.loading = false;
			
			if (result != null) {
				if (result.data.errors.length > 0) {
					for (let i = 0; i < result.data.errors.length; i++) {
						let message = result.data.errors[i].split(":");
						this.$notification.error(message[1]);
					}
				} else {
					this.$notification.success("Entrega processada com sucesso.");
					this.close();
				}
			} else {
				this.$notification.error("Não foi possível processar as informações.");
			}
			return;
		},

		// Fecha o modal
		close: function() {
			this.$parent.show_modal_form = false;
			this.$parent.current_form = null;
			this.$parent.load();
		},
	}
}
</script>

<style scoped>
.add-new-product {
	margin-top: 10px;
	border: none;
	background: #000;
	color: #d9d9d9;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
}

.remove-product {
	float: right;
	background-color: red;
	color: #fff;
	font-weight: 700;
	font-size: 12px;
	border: none;
	padding: 5px 15px;
}

.order-list-products {
	margin-bottom: 15px;
	border: 1px solid black;
}

.order-list-products-item {
	padding: 10px;
	border-top: 1px solid black;
	border-bottom: 1px solid black;
}

</style>